import { FiArrowRight, FiEye } from "react-icons/fi";

function formatValue(value) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  return value;
}

export default function MainStudentTable({ students, onView, selected, onSelect }) {
  return (
    <div className="overflow-hidden rounded-3xl border border-white/10 bg-slate-950/60 shadow-[0_24px_80px_rgba(15,23,42,0.38)]">
      <div className="hidden grid-cols-[1fr_1fr_1.4fr_160px] items-center gap-4 border-b border-white/10 bg-white/[0.04] px-6 py-4 text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-400 lg:grid">
        <span>Unique ID</span>
        <span>National ID or Passport Number</span>
        <span>Full Name</span>
        <span className="text-right">Action</span>
      </div>

      <div className="divide-y divide-white/10">
        {students.map((student, index) => {
          const isSelected = selected && (selected.passport_number === student.passport_number);
          return (
          <div
            key={student.passport_number || student.unique_id || index}
            onClick={() => onSelect && onSelect(isSelected ? null : student)}
            className={`group px-4 py-4 transition-colors lg:px-6 cursor-pointer ${isSelected ? "bg-indigo-500/10 border-l-2 border-indigo-400" : "hover:bg-white/[0.04]"}`}
          >
            <div className="grid gap-4 lg:grid-cols-[1fr_1fr_1.4fr_160px] lg:items-center">
              <div className="grid gap-4 sm:grid-cols-2 lg:contents">
                <div className="rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-3 lg:border-0 lg:bg-transparent lg:p-0">
                  <p className="mb-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500 lg:hidden">
                    Unique ID
                  </p>
                  <p className="font-semibold text-white">{formatValue(student.unique_id)}</p>
                </div>

                <div className="rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-3 lg:border-0 lg:bg-transparent lg:p-0">
                  <p className="mb-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500 lg:hidden">
                    National ID or Passport Number
                  </p>
                  <p className="text-slate-200">{formatValue(student.passport_number)}</p>
                </div>

                <div className="rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-3 lg:border-0 lg:bg-transparent lg:p-0">
                  <p className="mb-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500 lg:hidden">
                    Full Name
                  </p>
                  <div className="flex items-center justify-between gap-3">
                    <div>
                      <p className="font-semibold text-white">{formatValue(student.full_name)}</p>
                      <p className="mt-1 text-xs text-slate-400">
                        {formatValue(student.state)}
                        {student.category ? ` • ${student.category}` : ""}
                      </p>
                    </div>
                    <FiArrowRight className="hidden text-slate-500 transition-transform group-hover:translate-x-1 lg:block" />
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-end">
                <button
                  type="button"
                  onClick={(e) => { e.stopPropagation(); onView && onView(student); }}
                  className="inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-emerald-400/20 bg-emerald-500/10 px-4 py-3 text-sm font-semibold text-emerald-300 transition hover:border-emerald-300/40 hover:bg-emerald-500/20 hover:text-white lg:w-auto lg:min-w-[132px]"
                >
                  <FiEye size={16} />
                  View
                </button>
              </div>
            </div>
          </div>
          );
        })}
      </div>
    </div>
  );
}